import {
  GET_PROPERTY_SETTINGS_FAILURE,
  GET_PROPERTY_SETTINGS_REQUEST,
  GET_PROPERTY_SETTINGS_SUCCESS,
  PUT_PROPERTY_SETTINGS_FAILURE,
  PUT_PROPERTY_SETTINGS_REQUEST,
  PUT_PROPERTY_SETTINGS_SUCCESS,
} from '../../../actionConstants';

import apiClient from '../../../apiClient';

export const getPropertySettings = (dispatch, buildingId) =>
  dispatch({
    type: GET_PROPERTY_SETTINGS_REQUEST,
    payload: apiClient.buildingSettings.getPropertySettings(buildingId).then(
      (res) => {
        dispatch({
          type: GET_PROPERTY_SETTINGS_SUCCESS,
          buildingId,
          res,
        });
        return res;
      },
      (err) => {
        dispatch({
          type: GET_PROPERTY_SETTINGS_FAILURE,
          err,
        });
        return err;
      },
    ),
  });

export const putPropertySettings = (dispatch, buildingId, data) =>
  dispatch({
    type: PUT_PROPERTY_SETTINGS_REQUEST,
    isForm: true,
    payload: apiClient.buildingSettings
      .putPropertySettings(buildingId, data)
      .then(
        (res) => {
          dispatch({
            type: PUT_PROPERTY_SETTINGS_SUCCESS,
            buildingId,
            res,
          });
          return res;
        },
        (err) => {
          dispatch({
            type: PUT_PROPERTY_SETTINGS_FAILURE,
            err,
          });
          return err;
        },
      ),
  });
